<template>
  <div class="agreement-wrapper">
    <div class="title">{{$t('scope.text_355')}}</div>
    <div class="body">
      <div class="part">
        <div class="sub-title">{{$t('scope.text_356')}}</div>
        <div class="sub-content">
          <div class="left">1.1</div>
          <div class="right">{{$t('scope.text_357')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">1.2</div>
          <div class="right">{{$t('scope.text_358')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">1.3</div>
          <div class="right">{{$t('scope.text_359')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">1.4</div>
          <div class="right">{{$t('scope.text_360')}}</div>
        </div>
      </div>
      <div class="part">
        <div class="sub-title">{{$t('scope.text_361')}}</div>
        <div class="sub-content">
          <div class="left">2.1</div>
          <div class="right">{{$t('scope.text_362')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">2.2</div>
          <div class="right">{{$t('scope.text_363')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">2.3</div>
          <div class="right">{{$t('scope.text_364')}}</div>
        </div>
      </div>
      <div class="part">
        <div class="sub-title">{{$t('scope.text_365')}}</div>
        <div class="sub-content">
          <div class="left">3.1</div>
          <div class="right">{{$t('scope.text_366')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">3.1.1</div>
          <div class="right">{{$t('scope.text_367')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">3.1.2</div>
          <div class="right">{{$t('scope.text_368')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">3.1.3</div>
          <div class="right">{{$t('scope.text_369')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">3.1.4</div>
          <div class="right">{{$t('scope.text_370')}}</div>
        </div>
      </div>
      <div class="part">
        <div class="sub-title">{{$t('scope.text_371')}}</div>
        <div class="sub-content">
          <div class="left">4.1</div>
          <div class="right">{{$t('scope.text_372')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">4.2</div>
          <div class="right">{{$t('scope.text_373')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">4.3</div>
          <div class="right">{{$t('scope.text_374')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">4.4</div>
          <div class="right">{{$t('scope.text_375')}}</div>
        </div>
      </div>
      <div class="part">
        <div class="sub-title">{{$t('scope.text_376')}}</div>
        <div class="sub-content">
          <div class="left">5.1</div>
          <div class="right">{{$t('scope.text_377')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">5.2</div>
          <div class="right">{{$t('scope.text_378')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">5.3</div>
          <div class="right">{{$t('scope.text_379')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">5.4</div>
          <div class="right">{{$t('scope.text_380')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">5.5</div>
          <div class="right">{{$t('scope.text_381')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">5.6</div>
          <div class="right">{{$t('scope.text_382')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">5.7</div>
          <div class="right">{{$t('scope.text_383')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">5.8</div>
          <div class="right">{{$t('scope.text_384')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">5.9</div>
          <div class="right">{{$t('scope.text_385')}}</div>
        </div>
      </div>
      <div class="part">
        <div class="sub-title">{{$t('scope.text_386')}}</div>
        <div class="sub-content">
          <div class="left">6.1</div>
          <div class="right">{{$t('scope.text_387')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">6.2</div>
          <div class="right">{{$t('scope.text_388')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">6.3</div>
          <div class="right">{{$t('scope.text_389')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">6.4</div>
          <div class="right">{{$t('scope.text_390')}}</div>
        </div>
      </div>
      <div class="part">
        <div class="sub-title">{{$t('scope.text_391')}}</div>
        <div class="sub-content">
          <div class="left">7.1</div>
          <div class="right">{{$t('scope.text_392')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">7.2</div>
          <div class="right">{{$t('scope.text_393')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">7.3</div>
          <div class="right">{{$t('scope.text_394')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">7.4</div>
          <div class="right">{{$t('scope.text_395')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">7.5</div>
          <div class="right">{{$t('scope.text_396')}}</div>
        </div>
      </div>
      <div class="part">
        <div class="sub-title">{{$t('scope.text_397')}}</div>
        <div class="sub-content">
          <div class="left">8.1</div>
          <div class="right">{{$t('scope.text_398')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">8.2</div>
          <div class="right">{{$t('scope.text_399')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">8.3</div>
          <div class="right">{{$t('scope.text_400')}}</div>
        </div>
        <div class="sub-content">
          <div class="left">8.4</div>
          <div class="right">{{$t('scope.text_401')}}</div>
        </div>
      </div>
      <div class="part">
        <div class="sub-title">{{$t('scope.text_402')}}</div>
        <div class="sub-content">
          <div class="left">9.1</div>
          <div class="right">{{$t('scope.text_403')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Agreement',
}
</script>

<style lang="less" scoped>
.agreement-wrapper {
  width: 48%;
  min-width: 600px;
  margin: 40px auto 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.647058823529412);
  .title {
    font-weight: 600;
    font-size: 32px;
    height: 40px;
    line-height: 40px;
    color: #108DE9;
    margin-bottom: 10px;
  }
  .body {
    margin-bottom: 48px;
    .sub-title {
      font-weight: 500;
      line-height: 40px;
      height: 40px;
      color: rgba(0, 0, 0, 0.749019607843137);
      font-size: 16px;
    }
    .sub-content {
      display: flex;
      line-height: 24px;
      margin-bottom: 16px;
      .left {
        width: 70px;
        text-align: center;
      }
      .right {
        flex: 1;
      }
    }
  }
}
</style>
